/* Dinner Plate API — host + guest surfaces. */
import { api, API, getClientId } from "./api";
import axios from "axios";

// Host-side (uses shared axios with auth cookies)
export const dp = {
  parseMenu: async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const r = await api.post("/dinner-plate/parse-menu", fd,
      { headers: { "Content-Type": "multipart/form-data" }, timeout: 90000 });
    return r.data;
  },
  parseMenuBatch: async (files) => {
    const fd = new FormData();
    for (const f of files) fd.append("files", f);
    const r = await api.post("/dinner-plate/parse-menu-batch", fd,
      { headers: { "Content-Type": "multipart/form-data" }, timeout: 180000 });
    return r.data;
  },
  runtimeConfig: () => api.get("/dinner-plate/config").then(r => r.data),
  createEvent: (body) => api.post("/dinner-plate/events", body).then(r => r.data),
  listEvents:  () => api.get("/dinner-plate/events").then(r => r.data),
  getEvent:    (id) => api.get(`/dinner-plate/events/${id}`).then(r => r.data),
  updateEvent: (id, patch) => api.patch(`/dinner-plate/events/${id}`, patch).then(r => r.data),
  deleteEvent: (id) => api.delete(`/dinner-plate/events/${id}`).then(r => r.data),
  summary:     (id) => api.get(`/dinner-plate/events/${id}/summary`).then(r => r.data),
  // Downloads: use axios blob (auth cookies), then trigger a Save-As via object URL.
  download: async (id, kind /* 'pdf' | 'xlsx' */) => {
    const r = await api.get(`/dinner-plate/events/${id}/export.${kind}`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    // Prefer server-provided filename
    const cd = r.headers["content-disposition"] || "";
    const m = /filename="?([^"]+)"?/.exec(cd);
    a.download = m ? m[1] : `dinner-plate-${id}.${kind}`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};

// Guest-side (public, no auth — plain axios, no cookies to reduce CORS friction)
const publicClient = axios.create({ baseURL: API });
export const dpGuest = {
  event:       (slug) => publicClient.get(`/dinner-plate/e/${slug}`).then(r => r.data),
  submitOrder: (slug, body) => publicClient.post(`/dinner-plate/e/${slug}/orders`, body).then(r => r.data),
  getOrder:    (slug, code) => publicClient.get(`/dinner-plate/e/${slug}/orders/${code}`).then(r => r.data),
  editOrder:   (slug, code, patch) => publicClient.patch(`/dinner-plate/e/${slug}/orders/${code}`, patch).then(r => r.data),
};

// Keep unused imports referenced so bundler doesn't drop them if we need them later.
export const _unused_cid = getClientId;
